export const eventHub = {
    on(event: string, callback: Function) {
        document.addEventListener(event, (e: any) => callback(e.detail));
    },
    dispatch(event: string, data?: any) {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event: string, callback: Function) {
        document.removeEventListener(event, (e: any) => callback(e.detail));
    },
};